import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SiaBaseEditorSignalComponent } from '../sia-base-editor/sia-base-editor-signal.component';
import { SiaMapButtonComponent } from '../sia-map-button/sia-map-button.component';
import { SiaTextBoxComponent } from '../sia-text-box/sia-text-box.component';

@Component({
  selector: 'sia-map-box',
  templateUrl: './sia-map-box.component.html',
  styleUrls: ['./sia-map-box.component.scss'],
  standalone: true,
  imports: [SiaTextBoxComponent, SiaMapButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaMapBoxComponent extends SiaBaseEditorSignalComponent {}
